import { useEffect } from "react";
import { ErrorMessage } from "@hookform/error-message";
import {
  Radio as ChakraRadio,
  RadioGroup,
  Stack,
  Text,
  FormControl,
  FormErrorMessage,
  Checkbox,
} from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";

const Radio = ({
  options,
  name,
  instruction,
  builder,
  handleLinkForm,
  tabId,
  linkedTabs,
  type,
  required,
}: any) => {
  const {
    formState: { errors },
    register,
    getValues,
  } = useFormContext();

  const handleChange = (value: string) => {
    const option =
      builder?.options?.find((opt: any) => opt.option === value) || {};
    const newBuilders =
      linkedTabs?.find((tab: any) => tab.id === option?.linkedToFormId)
        ?.builders || option?.linkedForm?.builders;
    handleLinkForm && handleLinkForm(tabId, newBuilders, builder?.id);
  };

  const initialValue = getValues(name);

  useEffect(() => {
    if (name && initialValue) {
      handleChange(initialValue);
    }
  }, [getValues, name]);

  return (
    <>
      <FormControl isInvalid={!!errors[name]}>
        <Text
          mb="10px"
          fontWeight={500}
        >
          {instruction}
        </Text>
        {type === "radio" ? (
          <RadioGroup
            onChange={handleChange}
            name={name}
            defaultValue={initialValue}
          >
            <Stack direction="column">
              {options?.map((opt: any) => (
                <ChakraRadio
                  key={opt.id}
                  value={opt.option}
                  id={opt.id}
                  {...register(name, {
                    required: required ? `${instruction} is required` : false,
                  })}
                >
                  {opt.option}
                </ChakraRadio>
              ))}
            </Stack>
          </RadioGroup>
        ) : (
          <Stack direction="column">
            {options?.map((opt: any) => (
              <Checkbox
                key={opt.id}
                value={opt.option}
                id={opt.id}
                {...register(name, {
                  required: required ? `${instruction} is required` : false,
                })}
                onChange={(e) => handleChange(e.target.value)}
              >
                {opt.option}
              </Checkbox>
            ))}
          </Stack>
        )}
        <FormErrorMessage>
          <ErrorMessage
            errors={errors}
            name={name}
          />
        </FormErrorMessage>
      </FormControl>
    </>
  );
};

export default Radio;
